<template>
  <div class="grid-content">
    <div class="loading" v-loading="loading">
      <el-form ref="globalPriceSettings" :model="globalPriceSettings" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="3">
            <span>正常看视频(其他收费)：</span>
          </el-col>
          <el-col :span="6">
            <el-form-item label="每小时" prop="normalVideoPrice.Value">
              <el-input :disabled="optionModel.isReadonly" placeholder="请输入价格" v-model="globalPriceSettings.normalVideoPrice.Value" class="input-width">
                <template slot="append">$</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <hr>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <span>补看视频(课程报名)：</span>
          </el-col>
          <el-col :span="6">
            <el-form-item label="每节课" prop="supplementVideoPrice.Value">
              <el-input :disabled="optionModel.isReadonly" placeholder="请输入价格" v-model="globalPriceSettings.supplementVideoPrice.Value" class="input-width">
                <template slot="append">$</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <hr>
          </el-col>
        </el-row>
        <el-row v-show="false">
          <el-col :span="3">
            <span>视频预约定金：</span>
          </el-col>
          <el-col :span="6">
            <el-form-item label="每节课" prop="videoAppointmentDepositPrice.Value">
              <el-input :disabled="optionModel.isReadonly" placeholder="请输入价格" v-model="globalPriceSettings.videoAppointmentDepositPrice.Value"
                class="input-width">
                <template slot="append">$</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="false">
          <el-col :span="24">
            <hr>
          </el-col>
        </el-row>
        <table class="university-video-settings">
          <colgroup>
            <col />
            <col width="220" />
            <col width="200" />
            <col width="20" />
            <col width="220" />
            <col width="200" />
          </colgroup>
          <tr>
            <th>
              <span>大学视频价格设置：</span>
            </th>
            <th :colspan="2">
              <span>预约定金</span>
            </th>
            <th class="divider" />
            <th :colspan="2">
              <span>补看视频(视频预约)</span>
            </th>
          </tr>
          <tr v-for="setting in universityVideoPriceSettingList" :key="setting.UniversityGroupNumber">
            <td>
              <span>{{setting.UniversityGroupName}}</span>
            </td>
            <td>
              <el-form-item label="定金价格">
                <el-input :disabled="optionModel.isReadonly" placeholder="请输入定金价格" v-model="setting.VideoAppointmentDepositPriceSetting.Price"
                  class="input-width">
                  <template slot="append">$</template>
                </el-input>
              </el-form-item>
            </td>
            <td>
              <span>启用状态：</span>
              <span v-if="optionModel.isReadonly">{{setting.VideoAppointmentDepositPriceSetting.Enable ? "已启用" : "已停用"}}</span>
              <el-button v-else size="small" @click="setting.VideoAppointmentDepositPriceSetting.Enable=!setting.VideoAppointmentDepositPriceSetting.Enable"
                :type="!setting.VideoAppointmentDepositPriceSetting.Enable ? 'danger' : 'primary'"
                class="enableButton">{{!setting.VideoAppointmentDepositPriceSetting.Enable ? "已停用" : "已启用"}}</el-button>
            </td>
            <td class="divider" />
            <td>
              <el-form-item label="单次价格">
                <el-input :disabled="optionModel.isReadonly" placeholder="请输入单次价格" v-model="setting.SupplementVideoPriceSetting.Price" class="input-width">
                  <template slot="append">$</template>
                </el-input>
              </el-form-item>
            </td>
            <!-- <td>
              <el-form-item label="1小时价格">
                  <el-input :disabled="optionModel.isReadonly" placeholder="请输入1小时价格" v-model="setting.SupplementVideoPriceSetting.OneHourPrice"
                    class="input-width">
                    <template slot="append">$</template>
                  </el-input>
                </el-form-item>
            </td> -->
            <td>
              <span>省钱模式：</span>
              <span v-if="optionModel.isReadonly">{{setting.SupplementVideoPriceSetting.IsSavingMode ? "已启用" : "已停用"}}</span>
              <el-button v-else size="small" @click="setting.SupplementVideoPriceSetting.IsSavingMode=!setting.SupplementVideoPriceSetting.IsSavingMode"
                :type="!setting.SupplementVideoPriceSetting.IsSavingMode ? 'danger' : 'primary'"
                class="enableButton">{{!setting.SupplementVideoPriceSetting.IsSavingMode ? "已停用" : "已启用"}}</el-button>
            </td>
          </tr>
        </table>
        <el-row>
          <el-col :span="24">
            <hr>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row v-if="!optionModel.isReadonly" class="cs-filter-row">
      <el-col :span="4" class="footer-left">
        <el-button size="medium" :disabled="submitBtnDisable" :loading="isSaving" :type="submitBtnClass" @click="saveChanges">保存更新</el-button>
      </el-col>
      <el-col :span="16" class="footer-right">
        <el-alert :closable="false" v-show="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.el-col {
  span {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    overflow: visible;
    white-space: nowrap;
  }

  .el-input {
    text-align-last: center;
  }
}

.university-video-settings {
  width: 100%;

  .divider {
    border-left: 1px solid #dcdfe6;
  }

  td {
    vertical-align: top;
  }
}

.university-video-settings-title,
.university-video-settings-content {
  .divider {
    text-align: center;
    width: 20px;

    .el-divider {
      height: 40px;
    }
  }
}

.university-video-settings-title {
  margin-bottom: 22px;
}
</style>

<script>
import {
  getGlobalPriceSettingByType,
  saveGlobalPriceSetting,
} from "../../service/globalPriceSetting.service";
import {
  getUniversityVideoPriceSettingList,
  saveUniversityVideoPriceSettings,
} from "../../service/common.service";

export default {
  props: {
    isActive: Boolean,
    options: {
      isReadonly: Boolean,
    },
  },
  data() {
    let validateValue = (rule, value, callback) => {
      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);
      if (!!value && !isValid) {
        message = "请输入正确的价格";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      isLoadedData: false,
      loading: false,
      optionModel: {
        isReadonly: false,
      },
      globalPriceSettings: {
        normalVideoPrice: {},
        supplementVideoPrice: {},
        videoAppointmentDepositPrice: {},
      },
      universityVideoPriceSettingList: [],
      activeUniversityGroup: null,
      submitBtnClass: "info",
      submitBtnDisable: true,
      isSaving: false,
      showError: false,
      errorMessage: "",
      rules: {
        normalVideoPrice: {
          Value: [
            {
              required: true,
              message: "价格不能为空",
              trigger: "blur",
            },
            {
              validator: validateValue,
              trigger: "blur",
            },
          ],
        },
        supplementVideoPrice: {
          Value: [
            {
              required: true,
              message: "价格不能为空",
              trigger: "blur",
            },
            {
              validator: validateValue,
              trigger: "blur",
            },
          ],
        },
        videoAppointmentDepositPrice: {
          Value: [
            {
              required: true,
              message: "价格不能为空",
              trigger: "blur",
            },
            {
              validator: validateValue,
              trigger: "blur",
            },
          ],
        },
      },
    };
  },
  components: {},
  computed: {},
  created() {
    this.loadOptionModelFromProps();
    this.loadGlobalPriceSettings();
    this.loadUniversityVideoPriceSettingList();
  },
  updated() {
    this.checkAllInputs();
  },
  methods: {
    loadOptionModelFromProps(options = this.options) {
      if (!!options) {
        this.optionModel.isReadonly = options.isReadonly;
      } else {
        this.optionModel.isReadonly = false;
      }
    },
    checkAllInputs() {
      let isValid = true;

      let $refGPS = this.$refs["globalPriceSettings"];
      if (!!$refGPS) {
        $refGPS.validate((valid) => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }

      if (isValid) {
        this.submitBtnClass = "primary";
        this.submitBtnDisable = false;
      } else {
        this.submitBtnClass = "info";
        this.submitBtnDisable = true;
      }

      return isValid;
    },
    async loadGlobalPriceSettings() {
      if (!this.isActive) {
        return;
      }

      let self = this;

      this.loading = true;
      await getGlobalPriceSettingByType(2).then((result) => {
        if (!!result && result.success) {
          self.globalPriceSettings.normalVideoPrice = result.data;
        }
      });

      await getGlobalPriceSettingByType(3).then((result) => {
        if (!!result && result.success) {
          self.globalPriceSettings.supplementVideoPrice = result.data;
        }
      });

      await getGlobalPriceSettingByType(13).then((result) => {
        if (!!result && result.success) {
          self.globalPriceSettings.videoAppointmentDepositPrice = result.data;
        }
      });

      this.loading = false;
      this.isLoadedData = true;
    },
    async loadUniversityVideoPriceSettingList() {
      this.loading = true;

      try {
        let result = await getUniversityVideoPriceSettingList();
        if (!!result && result.success) {
          this.universityVideoPriceSettingList = result.data;

          let firstSetting =
            this.universityVideoPriceSettingList.length > 0
              ? this.universityVideoPriceSettingList[0]
              : null;
          this.activeUniversityGroup = !!firstSetting
            ? firstSetting.UniversityGroupNumber
            : null;
        } else {
          this.universityVideoPriceSettingList = [];
          this.activeUniversityGroup = null;
        }
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    async saveChanges() {
      let self = this;

      let isValid = this.checkAllInputs();
      if (!isValid) {
        return;
      }
      this.isSaving = true;
      let cacheSubmitBtnDisable = this.submitBtnDisable;
      this.submitBtnDisable = true;

      let showError = false;
      let errorMessage = "";

      await saveGlobalPriceSetting(
        this.globalPriceSettings.normalVideoPrice
      ).then((result) => {
        if (!result) {
          return;
        }

        if (result.success) {
          self.globalPriceSettings.normalVideoPrice.Id = result.data;
        } else {
          showError = true;
          errorMessage += result.message;
        }
      });

      await saveGlobalPriceSetting(
        this.globalPriceSettings.supplementVideoPrice
      ).then((result) => {
        if (!result) {
          return;
        }

        if (result.success) {
          self.globalPriceSettings.supplementVideoPrice.Id = result.data;
        } else {
          showError = true;
          errorMessage += result.message;
        }
      });

      await saveGlobalPriceSetting(
        this.globalPriceSettings.videoAppointmentDepositPrice
      ).then((result) => {
        if (!result) {
          return;
        }

        if (result.success) {
          self.globalPriceSettings.videoAppointmentDepositPrice.Id =
            result.data;
        } else {
          showError = true;
          errorMessage += result.message;
        }
      });

      await saveUniversityVideoPriceSettings(
        this.universityVideoPriceSettingList
      ).then((result) => {
        if (!result) {
          return;
        }

        if (result.success) {
          self.universityVideoPriceSettingList = result.data;
        } else {
          showError = true;
          errorMessage += result.message;
        }
      });

      this.$message(`保存更新${!showError ? "成功" : "失败"}`);
      this.showError = showError;
      this.errorMessage = errorMessage;

      this.submitBtnDisable = cacheSubmitBtnDisable;
      this.isSaving = false;
    },
  },
  watch: {
    isActive: function () {
      if (this.isActive && !this.isLoadedData) {
        this.loadGlobalPriceSettings();
        this.loadUniversityVideoPriceSettingList();
      }
    },
    options: function (newVal) {
      this.loadOptionModelFromProps(newVal);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/videoUnitPrice.vue